import Head from "@app/components/Head";
import React from "react";
import TableJuries from "src/sections/Table/TableJuries";

function DashbordAdmin() {
  return (
    <>
      <Head options={{ title: "Dashboard Jury" }} />
      <section className="container py-24">
        <TableJuries />
      </section>
    </>
  );
}

export default DashbordAdmin;
